const sids = [
  'jig',
  'talentpool',
  'edunet',
  'wconat',
  'ncph',
  't4a',
  'edunetke',
  'edunetasia',
  'edunetma',
  'kh',
  'rhh',
  'he',
  'jobtalent',
  'edunetin',
  'jnjts',
  'ragtp',
  'kle',
  'bbg',
  'wrktp',
  'amseu',
  'coe',
  'jnjtseu',
  'jnjtsat',
  'en',
  'bbw',
  'bfz',
];
const sidCurses = [
  'jobtalent',
  'jnjts',
  'jnjtseu',
  'jnjtsat',
  'ragtp',
  'kle',
  'en',
  'bbg',
  'wrktp',
  'coe',
  'bbw',
  'bfz',
];
const sidsIndividualBanner = [
  'edunetke',
  'edunetasia',
  'edunetma',
  'edunetin',
  'kle',
  'en',
  'bbg',
  'coe',
  'bbw',
  'bfz',
];

// банер береться з налаштувань порталу (settingPortal.header_image), а не з локальних ассетів
const sidsPortalBanner = [
  'bbg',
];

const sidsProfessionQueryTsp = [
  'jnjts',
  'jnjtseu',
  'jnjtsat',
];

const sidsNewProfileConsultant = [
  'wrktp',
  'jnjts',
  'jnjtseu',
  'jnjtsat',
];

const sidsEnabledChat = [
  'wrktp',
  'jnjts',
  'jnjtseu',
  'jnjtsat',
  'coe',
  'kle',
  'en',
  'bbg',
  'bbw',
  'bfz',
];

const sidsCompanyQuery = [
  'kle',
  'en',
  'bbg',
  'coe',
  'bbw',
  'bfz',
];
const sidsFontTemplate = [
  'talentpool',
  'edunet',
  'edunetke',
  'edunetasia',
  'edunetma',
  'wconat',
  'ncph',
  't4a',
  'kh',
  'rhh',
  'he',
  'jobtalent',
  'edunetin',
  'jnjts',
  'jnjtseu',
  'jnjtsat',
  'kle',
  'en',
  'bbg',
  'wrktp',
  'amseu',
  'coe',
  'bbw',
  'bfz',
];
const sidsNewCabinet = [
  'aba',
  'abatest',
  'talentpool',
  'jig',
  'edunet',
  'edunetke',
  'edunetasia',
  'edunetma',
  'wconat',
  'ncph',
  't4a',
  'kh',
  'rhh',
  'he',
  'jobtalent',
  'edunetin',
  'jnjts',
  'wrktp',
  'amseu',
  'coe',
  'kle',
  'en',
  'bbg',
  'jnjtseu',
  'jnjtsat',
  'bbw',
  'bfz',
];

const sidsLocationCountryFilter = [
  'jnjts',
  'jnjtseu',
  'jnjtsat',
  'wrktp',
];

export const group = (sid: string) => sids.includes(sid);
export const individualBannerGroup = (sid: string) => sidsIndividualBanner.includes(sid);
export const portalBannerGroup = (sid: string) => sidsPortalBanner.includes(sid);
export const groupCurses = (sid: string) => sidCurses.includes(sid);
export const groupProfessionQueryTsp = (sid: string) => sidsProfessionQueryTsp.includes(sid);
export const groupNewProfileConsultant = (sid: string) => sidsNewProfileConsultant.includes(sid);
export const groupEnabledChat = (sid: string) => sidsEnabledChat.includes(sid);
export const groupCompanyQuery = (sid: string) => sidsCompanyQuery.includes(sid);
export const groupFontTemplate = (sid: string) => sidsFontTemplate.includes(sid);
export const groupNewCabinet = (sid: string) => sidsNewCabinet.includes(sid);
export const groupLocationCountryFilter = (sid: string) => sidsLocationCountryFilter.includes(sid);
